import TripsIdeasTab from './TripsIdeasTab';
import './TripsIdeasTab.scss';

export default TripsIdeasTab;
